import { Box, Link, Skeleton, Spacer } from "@aviary";
import type { WordpressSearchLandingPageType } from "@emerson/types/WordpressSearchLandingPageType";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./ProductBanner.styles";

interface Props {
  banner: WordpressSearchLandingPageType | null;
  isLoading?: boolean;
}

const ProductBanner = ({ banner = null, isLoading }: Props) => {
  const { tablet } = useBreakpoints();
  const isDesktop = tablet.greaterThan;

  if (!banner) return null;

  const bannerImage = isDesktop
    ? banner?.searchLandingImageDesktop
    : banner?.searchLandingImageMobile;

  if (!bannerImage) return null;

  if (isLoading) {
    return (
      <>
        <Skeleton type="image" css={styles.banner} />
        <Spacer height="double" />
      </>
    );
  }
  const to = banner.searchLandingActionUrl || banner.searchLandingFsActionUrl;

  return (
    <>
      <Link
        css={styles.bannerButton}
        data-testid="shop-banner"
        noExternalIcon
        to={to}
        aria-disabled
      >
        <Box
          style={
            {
              "--banner-image": `url(${bannerImage})`,
            } as React.CSSProperties
          }
          css={styles.banner}
        />
      </Link>
      <Spacer height="oneHalf" />
    </>
  );
};

export { ProductBanner };
